import React from 'react';
import Root from './root';

export const Entry = () => {
	return <Root />;
};
